// tslint:disable-next-line: no-submodule-imports
import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchSkyfireMethods } from '../utils';
import * as Styles from './Notification.scss';
const nativeAppImageSrc = 'https://d5fx445wy2wpk.cloudfront.net/static/logo_native_app.png';
export default function Tooltip(props) {
    var _a;
    useStyles(Styles);
    const dispatch = useDispatch();
    const { tooltip } = useSelector((state) => state.Tooltip);
    const { mediaId } = useSelector((state) => state.Media);
    const { overlayTemplates } = useSelector((state) => state.TemplateStack);
    const { isSearchBoxFocused } = useSelector((state) => state.SearchSuggestions);
    const hasOverlay = overlayTemplates.length > 0;
    const isNowPlaying = this.props.isNowPlaying;
    if (!tooltip || (hasOverlay && !isNowPlaying) || isSearchBoxFocused) {
        return null;
    }
    const closeCallback = useCallback((event) => {
        var _a;
        (_a = event) === null || _a === void 0 ? void 0 : _a.preventDefault();
        const { onItemSelected } = tooltip.closeButton.primaryLink;
        dispatchSkyfireMethods(dispatch, props.template, onItemSelected);
    }, [dispatch, tooltip]);
    const secondaryActionButtonCallback = useCallback((event) => {
        var _a;
        (_a = event) === null || _a === void 0 ? void 0 : _a.preventDefault();
        if (!tooltip.secondaryActionButton) {
            return;
        }
        const { onItemSelected } = tooltip.secondaryActionButton.primaryLink;
        dispatchSkyfireMethods(dispatch, props.template, onItemSelected);
    }, [dispatch, tooltip]);
    const actionButtonCallback = useCallback((event) => {
        event.preventDefault();
        const { onItemSelected } = tooltip.actionButton.primaryLink;
        dispatchSkyfireMethods(dispatch, props.template, onItemSelected);
    }, [dispatch, tooltip]);
    useEffect(() => {
        const timer = setTimeout(() => {
            closeCallback();
        }, tooltip.timeoutMilliseconds);
        return () => clearTimeout(timer);
    }, [tooltip]);
    useEffect(() => {
        dispatchSkyfireMethods(dispatch, props.template, tooltip.onViewed);
    }, [tooltip]);
    const actionButton = tooltip.actionButton && (React.createElement("music-button", { size: "small", href: tooltip.actionButton.primaryLink.deeplink, onClick: actionButtonCallback, slot: "buttons", variant: "solid" }, tooltip.actionButton.text));
    const secondaryActionButton = tooltip.secondaryActionButton && (React.createElement("music-button", { size: "small", href: tooltip.secondaryActionButton.primaryLink.deeplink, onClick: secondaryActionButtonCallback, slot: "buttons", variant: "outline" }, tooltip.secondaryActionButton.text));
    const image = tooltip.id === 'native-app-upsell' ? nativeAppImageSrc : null;
    return (React.createElement("music-tooltip", { id: tooltip.id, "primary-text": tooltip.message, "secondary-text": tooltip.title, className: [Styles.tooltip, 'hydrated', mediaId ? Styles.media : null, isNowPlaying ? Styles.nowPlayingView : null].join(' '), kind: "accent", closable: !!((_a = tooltip) === null || _a === void 0 ? void 0 : _a.closeButton), onmusicTooltipCloseButtonActivate: closeCallback, "image-src": image },
        secondaryActionButton,
        actionButton));
}
;
